import React from "react";

import { Box, styled, Tab, Tabs } from "@mui/material";
import PaletteIcon from "@mui/icons-material/Palette";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const StyledTab = styled(Tab)(
  () => `
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  white-space: nowrap;
  min-height: 44px;
  min-width: 0;
  padding: 0px 6px;
  gap: 2px;
  & .MuiSvgIcon-root {
    font-size: 18px;
  }
`,
);

interface SubtitleModeSwitcherProps {
  selectedTab: number;
  onSelectTab: (tab: number) => void;
}

export default function SubtitleModeSwitcher({
  selectedTab,
  onSelectTab,
}: SubtitleModeSwitcherProps) {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    onSelectTab(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        marginBottom: "8px",
        gap: 2,
      }}
    >
      <Tabs value={selectedTab} onChange={handleTabChange} variant="fullWidth">
        <StyledTab
          label="Presets"
          icon={<AutoAwesomeIcon />}
          iconPosition="start"
          onClick={() => onSelectTab(0)}
        />
        <StyledTab
          label="Style"
          icon={<PaletteIcon />}
          iconPosition="start"
          onClick={() => onSelectTab(1)}
        />
        <StyledTab
          label="Edit text"
          icon={<EditNoteIcon />}
          iconPosition="start"
          onClick={() => onSelectTab(2)}
        />
      </Tabs>
    </Box>
  );
}
